import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../utils/apiClient';
import { FiLogOut } from 'react-icons/fi';
import '../styles/Admin.css';

const AdminDashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [adminName, setAdminName] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = sessionStorage.getItem('adminToken');
        if (!token) {
            navigate('/admin/login');
            return;
        }
        setAdminName(sessionStorage.getItem('adminName') || 'Admin');
        fetchStats();
    }, [navigate]);

    const fetchStats = async () => {
        try {
            const token = sessionStorage.getItem('adminToken');
            const response = await apiClient.get('/admin/stats', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setStats(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching stats:', error);
            setLoading(false);
        }
    };

    const handleLogout = () => {
        sessionStorage.clear();
        navigate('/admin/login');
    };

    if (loading) return <div className="admin-container">Loading...</div>;

    return (
        <div className="admin-container">
            <div className="admin-header">
                <div className="header-left">
                    <h1>Admin Dashboard</h1>
                </div>
                <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <span className="admin-welcome">Welcome, <strong>{adminName}</strong></span>
                    <button onClick={handleLogout} className="logout-btn" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 16px',
                        background: '#ffebee',
                        color: '#c62828',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: '600'
                    }}>
                        <FiLogOut /> Logout
                    </button>
                </div>
            </div>

            {stats && (
                <div className="dashboard-stats">
                    <div className="stat-card">
                        <h3>Total Revenue</h3>
                        <p style={{ color: '#2e7d32' }}>₹{stats.totalRevenue.toLocaleString()}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Total Orders</h3>
                        <p style={{ color: '#1976d2' }}>{stats.totalOrders}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Total Products</h3>
                        <p style={{ color: '#ed6c02' }}>{stats.totalProducts}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Total Users</h3>
                        <p style={{ color: '#9c27b0' }}>{stats.totalUsers}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminDashboard;
